import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import FieldsMappingLine from 'containers/settings/deprecatedIntegrationsManagement/components/FieldsMappingLine';
import { InfoAlert, ErrorAlert } from 'components/alerts';
import './style.scss';

class FieldsMapping extends PureComponent {
    state = {};

    constructor(props) {
        super(props);
    }

    renderAlertErrors(type) {
        let { stepperAlertErrors } = this.props;
        if (
            !stepperAlertErrors ||
            !stepperAlertErrors[type] ||
            (stepperAlertErrors[type] && !stepperAlertErrors[type].errors)
        ) {
            return null;
        }
        return (
            <div className="fields-mapping-alert fields-mapping-error">
                <ErrorAlert
                    title={stepperAlertErrors[type].title}
                    text={stepperAlertErrors[type].text}
                    shrink={true}
                />
            </div>
        );
    }

    render() {
        const {
            fields,
            selectFields,
            fieldsConfig,
            onFieldsSelChange,
            onFieldsDefaultChange,
            getFmValuelist,
            literals,
            stepperAlertErrors,
        } = this.props;
        let lines = [];
        let infoAlertText;
        if (fieldsConfig.bidirectional) {
            infoAlertText =
                literals['label_integration_bidirectional_info_box'] ||
                'label_integration_bidirectional_info_box';
        } else if (fieldsConfig.outgoing) {
            infoAlertText =
                literals['label_integration_unidirectional_outgoing_info_box'] ||
                'label_integration_unidirectional_outgoing_info_box';
        } else {
            infoAlertText =
                literals['label_integration_unidirectional_info_box'] ||
                'label_integration_unidirectional_info_box';
        }
        Object.keys(fields).map((key, index) => {
            if (!fieldsConfig.fieldRelation[key].readOnly) {
                let entity = fieldsConfig.forcemanagerEntity;
                let fieldType = 'all';
                if (!fieldsConfig.noType) {
                    fieldType = fields[key].FMType === 0 ? 'notList' : 'list';
                }
                let fmValueList = [];
                let handleOnFieldsSelChange = (oldValue, newValue, actionMeta) =>
                    onFieldsSelChange(entity, fieldType, key, oldValue, newValue, actionMeta);
                let handleOnFieldDefaultChange = (newValue, actionMeta) =>
                    onFieldsDefaultChange(entity, fieldType, key, newValue, actionMeta);
                let stepperAlertErrorsFm =
                    (stepperAlertErrors.fm &&
                        stepperAlertErrors.fm.obj &&
                        stepperAlertErrors.fm.obj[key]) ||
                    false;
                let stepperAlertErrorsExt =
                    (stepperAlertErrors.ext &&
                        stepperAlertErrors.ext.obj &&
                        stepperAlertErrors.ext.obj[key]) ||
                    false;
                if (fmValueList && fmValueList[fields[key].LinkedTable]) {
                    fmValueList = fmValueList[fields[key].LinkedTable].data.reduce((accum, el) => {
                        return [...accum, { value: el['-id'], label: el.descripcion }];
                    }, {});
                }
                const fieldConfig = fieldsConfig.outgoing
                    ? fieldsConfig.fieldRelation[fields[key]['value']]
                    : fieldsConfig.fieldRelation[fields[key]['RestAPIName']];
                lines.push(
                    <FieldsMappingLine
                        key={index}
                        field={fields[key]}
                        fieldConfig={fieldConfig}
                        selectFields={selectFields}
                        bidirectional={fieldsConfig.bidirectional}
                        outgoing={fieldsConfig.outgoing}
                        fieldType={fieldType}
                        onFieldsSelChange={handleOnFieldsSelChange}
                        onFieldDefaultChange={handleOnFieldDefaultChange}
                        getFmValuelist={getFmValuelist}
                        fmValueList={fmValueList}
                        literals={literals}
                        stepperAlertErrorsFm={stepperAlertErrorsFm}
                        stepperAlertErrorsExt={stepperAlertErrorsExt}
                    />,
                );
            }
        });
        const fmHeaderLiteral = (
            <Literal
                literal={
                    literals['label_integration_forcemanager_fields'] ||
                    'label_integration_forcemanager_fields'
                }
            />
        );
        const extHeaderLiteral = (
            <Literal
                literal={literals['label_integration_ext_fields'] || 'label_integration_ext_fields'}
            />
        );
        return (
            <div className="fields-mapping">
                <div className="fields-mapping-alert fields-mapping-info">
                    <InfoAlert
                        className="fields-mapping-alert"
                        text={<Literal literal={infoAlertText} />}
                        icon={'icon'}
                        shrink={true}
                    />
                </div>
                {this.renderAlertErrors('fm')}
                {fieldsConfig.bidirectional ? this.renderAlertErrors('ext') : null}
                <div className="fields-mapping-headers">
                    {fieldsConfig.outgoing ? extHeaderLiteral : fmHeaderLiteral}
                    {fieldsConfig.outgoing ? fmHeaderLiteral : extHeaderLiteral}
                    <Literal literal={literals['label_default'] || 'label_default'} />
                </div>
                <div className="fields-mapping-lines">{lines}</div>
            </div>
        );
    }
}

export default FieldsMapping;
